var EUserEventNames = /* @__PURE__ */ ((EUserEventNames2) => {
  EUserEventNames2["ON_CHANGE_LOG_LEVEL"] = "onChangeLogLevel";
  return EUserEventNames2;
})(EUserEventNames || {});
export {
  EUserEventNames
};
